import { useLocation } from 'react-router-dom';
import type { IconType } from 'react-icons';
import { FaBook, FaChalkboardTeacher } from 'react-icons/fa';
import { GrDocumentText } from 'react-icons/gr';
import { LuClipboardList } from 'react-icons/lu';
import { MdPerson, MdGroups, MdSettings } from 'react-icons/md';
import { TiHome } from 'react-icons/ti';
import { Role } from '#/store/slices/api/types/user';

export interface RouteInfo {
  userTypes: Role[];
  icon: IconType;
}

export const routeInfo: Record<string, RouteInfo> = {
  '': { userTypes: [Role.ADMINISTRATOR, Role.INSTRUCTOR], icon: TiHome }, // Dashboard (/)
  'instructors': { userTypes: [Role.ADMINISTRATOR], icon: FaChalkboardTeacher },
  'students': { userTypes: [Role.ADMINISTRATOR, Role.INSTRUCTOR], icon: MdGroups },
  'administrators': { userTypes: [Role.ADMINISTRATOR], icon: MdPerson },
  'classes': { userTypes: [Role.ADMINISTRATOR, Role.INSTRUCTOR], icon: FaBook },
  'reports': { userTypes: [Role.ADMINISTRATOR, Role.INSTRUCTOR], icon: GrDocumentText },
  'assessments': { userTypes: [Role.ADMINISTRATOR], icon: LuClipboardList },
  'settings': { userTypes: [Role.ADMINISTRATOR], icon: MdSettings },
  'profile': { userTypes: [Role.ADMINISTRATOR, Role.INSTRUCTOR], icon: MdPerson }
};

export function useRouteInfo() {
  const { pathname } = useLocation();
  const firstPathSegment = pathname.split('/')[1];
  return routeInfo[firstPathSegment];
}
